import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const projects = [
  {
    title: 'Konut Projeleri',
    count: '200+',
    desc: 'Apartman, site ve rezidans projeleri',
    image:
      'https://public.readdy.ai/ai/img_res/561676aa943312603c44c5d1fdab8e72.jpg',
  },
  {
    title: 'Ticari Binalar',
    count: '150+',
    desc: 'Ofis, AVM ve otel projeleri',
    image:
      'https://readdy.ai/api/search-image?query=Modern%20corporate%20office%20building%20with%20sleek%20glass%20and%20steel%20facade%20reflecting%20blue%20sky%2C%20contemporary%20business%20architecture%20with%20clean%20geometric%20lines%2C%20professional%20architectural%20photography%20during%20golden%20hour%20with%20warm%20ambient%20lighting%20and%20clear%20background&width=600&height=450&seq=ref-commercial-updated-v1&orientation=landscape',
  },
  {
    title: 'Endüstriyel Tesisler',
    count: '100+',
    desc: 'Fabrika, depo ve üretim tesisleri',
    image:
      'https://readdy.ai/api/search-image?query=Modern%20industrial%20facility%20and%20warehouse%20exterior%20with%20large%20metal%20structure%2C%20clean%20industrial%20architecture%2C%20professional%20photography%2C%20clear%20sky%20background&width=600&height=450&seq=ref-industrial-v3&orientation=landscape',
  },
];

export default function ProjectsSection() {
  return (
    <section className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <span className="text-sm font-semibold text-red-600 tracking-wider uppercase">
            Referanslar
          </span>
          <h4 className="text-3xl lg:text-4xl font-bold text-gray-900 mt-3 mb-4">
            <a href="#" className="cursor-default">
              Başarıyla Tamamlanan Projeler
            </a>
          </h4>
          <p className="text-gray-600 max-w-2xl mx-auto">
            Farklı sektörlerde gerçekleştirdiğimiz yangın güvenlik projelerimiz
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8">
          {projects.map((project, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.15, duration: 0.5 }}
              className="group bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-300"
            >
              <div className="relative w-full h-56 overflow-hidden">
                <img
                  src={project.image}
                  alt={project.title}
                  title={`${project.title} yangın algılama sistemi kurulumu`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-4 right-4 bg-red-600 text-white px-4 py-1.5 rounded-full text-sm font-bold">
                  {project.count}
                </div>
              </div>
              <div className="p-6">
                <h3 className="text-lg font-bold text-gray-900 mb-1">{project.title}</h3>
                <p className="text-gray-500 text-sm">{project.desc}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
